import React from 'react';
import AppImage from '@/components/ui/AppImage';
import { Link } from 'react-router-dom';
import Icon from '@/components/ui/AppIcon';
export default function EventsHero() {
    return (<section className="relative min-h-[45vh] flex items-end overflow-hidden" aria-label="Events page hero">
      <AppImage src="/assets/images/images__2_-1787466601321.jpeg" alt="Packed concert venue with golden stage spotlights, dramatic low-angle shot, dark atmospheric interior, energetic crowd" fill priority sizes="100vw" className="object-cover object-center"/>

      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/30"/>
      <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-black/40"/>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pb-12 pt-32">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 text-xs text-muted-foreground mb-4">
          <Link to="/" className="hover:text-primary transition-colors">Home</Link>
          <Icon name="ChevronRightIcon" size={12}/>
          <span className="text-primary">Events</span>
        </div>
        <p className="section-label mb-3">All Events</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-foreground leading-tight max-w-2xl">
          Upcoming <span className="gold-gradient">Performances</span>
        </h1>
        <p className="text-foreground/70 text-base mt-4 max-w-xl leading-relaxed">
          Discover world-class Sri Lankan entertainment events across Australia. Book your seats before they sell out.
        </p>
      </div>
    </section>);
}
